// extracted by mini-css-extract-plugin
export default {"terminosYCondicionesBody":"TerminosYCondicionesProductores_terminosYCondicionesBody__xkuoO","condiciones":"TerminosYCondicionesProductores_condiciones__QwfAF"};